module.exports = __webpack_public_path__ + "img/conhome-full-logo-fixed.e6ede0eb.svg";